import { css } from 'styled-components';

export const bodyWrapper = css`
  flex-grow: 1;
  overflow-y: scroll;
`;
